import React, { useEffect } from 'react'
import classNames from 'classnames'
import { useNavContext } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/useNavContext'
import MobileSubMenu from './MobileSubMenu'
import MobileParentMenu from './MobileParentMenu'
import useWindowSize from '@toasttab/shared/src/hooks/useWindowSize'
import MobileMenuFooter from './MobileMenuFooter'
import ShowcaseEntry from '@toasttab/shared/src/components/organisms/Navigation/Contentful/ShowcaseEntry'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'

const MobileNav = () => {
  const { headerHeight } = usePageContext()
  const {
    isMobileNavOpen,
    mobileShowcase,
    navigationData,
    setIsMobileNavOpen,
    setIsRegionMenuOpen,
    setSelectedParentMenu
  } = useNavContext()

  const windowSize = useWindowSize()
  const isDesktopLayout = windowSize.width >= 1024

  useEffect(() => {
    const bodyEl = document.getElementsByTagName('body')

    if (isMobileNavOpen) {
      bodyEl[0].style.overflow = 'hidden'
    } else {
      bodyEl[0].style.removeProperty('overflow')
    }
  })

  const mobileNavigationCss = classNames(
    'fixed z-[90] md:z-[95] bg-white transition-right md:transition-left !duration-500 md:border-r md:border-gray-25 w-full md:max-w-[375px] w-screen',
    {
      'right-[-800px] md:left-[-500px]': !isMobileNavOpen || isDesktopLayout,
      'right-0 md:left-0': isMobileNavOpen && !isDesktopLayout
    }
  )

  const overlayCss = classNames('overlay', {
    hidden: !isMobileNavOpen || isDesktopLayout,
    'fixed bg-black opacity-30 w-full h-full z-[80]':
      isMobileNavOpen && !isDesktopLayout
  })

  const handleCloseButton = () => {
    setIsMobileNavOpen(false)
    setSelectedParentMenu(null)
    setIsRegionMenuOpen(false)
  }

  return (
    <>
      <div
        className={mobileNavigationCss}
        data-testid='MobileNav'
        id='mobile-nav-menu'
        style={{
          height: `calc(100dvh - ${headerHeight}px)`,
          top: `${headerHeight}px`
        }}
      >
        <nav
          aria-hidden={!isMobileNavOpen}
          aria-label='Toast Mobile Navigation'
          className='flex flex-col relative z-[100] pb-6 h-full bg-white overflow-y-scroll !no-scrollbar'
          data-testid='MobileNav-parentNav'
          id='mobile-parent-nav'
        >
          <div className='flex-shrink-0'>
            {navigationData.menus?.map((menu: any) => (
              <MobileParentMenu key={menu.title} {...menu} />
            ))}
          </div>
          {mobileShowcase ? (
            <div className='p-4 md:hidden'>
              <ShowcaseEntry
                dataTestId='MobileNav-showcaseEntry'
                isMobileMainNav
                menuType='mobile'
                {...mobileShowcase}
              />
            </div>
          ) : null}
          <div className='mt-auto px-4 flex-shrink-0'>
            <MobileMenuFooter dataTestId='MobileNav-menuFooter' />
          </div>
        </nav>
        {navigationData?.menus?.map((menu: any) => (
          <MobileSubMenu
            handleCloseButton={handleCloseButton}
            key={menu.title}
            showcaseEntries={menu.dropdownContent?.showcaseEntries}
            subMenus={menu.dropdownContent?.subMenus}
            title={menu.title}
          />
        ))}
      </div>
      <div
        className={overlayCss}
        data-testid='MobileNav-overlay'
        onClick={handleCloseButton}
        style={{
          height: `calc(100dvh - ${headerHeight}px)`,
          top: `${headerHeight}px`
        }}
      />
    </>
  )
}

export default MobileNav
